import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const TABS = [
  { to: '/admin',           label: 'Overview', end: true },
  { to: '/admin/todos',     label: 'To-Dos' },
  { to: '/admin/members',   label: 'Members' },
  // Standalone, one click from anywhere — the same page also lives buried
  // inside BackEnd's "Hub Events (manual corrections)" tab, which is fine
  // for the rare manual-correction case but was the real cause of hosts
  // (Patti, 2026-09-20) needing 4+ navigation steps just to start hosting a
  // live event. Prototype, staging only — a nav change, Jenn's call before
  // it goes live.
  { to: '/admin/hub-events', label: 'Events' },
  { to: '/admin/courses',   label: 'Courses' },
  { to: '/admin/community', label: 'Community' },
  { to: '/admin/sequence-content', label: 'Content Pushes' },
  { to: '/admin/bunny-library', label: 'Video Library' },
  { to: '/admin/requests', label: 'Requests' },
  { to: '/admin/coupons', label: 'Coupons' },
  { to: '/admin/backend', label: 'BackEnd' },
];

/** Small tab bar shared across admin-only pages. */
export default function AdminNav() {
  const { user } = useAuth();
  // Affiliate/royalty data is restricted separately from general admin
  // access — see requireAffiliateManager server-side. Only shown here if
  // this admin actually has that permission, not just the 'admin' role.
  // Sales & Marketing (Jenn, 2026-09-28) shows revenue, so it sits behind the
  // same permission, right next to Affiliates.
  // Since 2026-10-13 Sales & Marketing also shows for people Jenn has given
  // can_see_sales_marketing (Patti, Trish) — without Affiliates or Money.
  const tabs = user?.can_manage_affiliates
    ? [...TABS, { to: '/admin/affiliate-manager', label: 'Affiliates' }, { to: '/admin/sales-marketing', label: 'Sales & Marketing' }, { to: '/admin/money', label: 'Money' }]
    : user?.can_see_sales_marketing ? [...TABS, { to: '/admin/sales-marketing', label: 'Sales & Marketing' }]
    : TABS;

  return (
    <div className="flex gap-1 bg-gray-100 rounded-lg p-1 text-xs font-medium w-fit max-w-full overflow-x-auto mb-6">
      {tabs.map(tab => (
        <NavLink
          key={tab.to}
          to={tab.to}
          end={tab.end}
          className={({ isActive }) =>
            `px-3 py-1.5 rounded-md whitespace-nowrap shrink-0 transition-colors ${
              isActive ? 'bg-white text-reset-brown shadow-sm' : 'text-gray-500 hover:text-reset-brown'
            }`
          }
        >
          {tab.label}
        </NavLink>
      ))}
    </div>
  );
}
